import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    activeCategory: null,
    // loading: false,
    // error: false
};

const CategoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        setActiveCategory: (state, { payload }) => {
            state.activeCategory = payload;
        },
    },
    extraReducers: builder => {},
});

export const CategoriesReducer = CategoriesSlice.reducer;
export const CategoriesActions = {
    ...CategoriesSlice.actions,
};
